import { Components } from "appworks/components/components";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { IdleState } from "slotworks/state-machine/standard/states/idle-state";

export class FowlSlotBonusIdleState extends IdleState {
    public onEnter() {
        uiFlags.set(UIFlag.IDLE, true);
    }

    public onExit() {
        Components.get(AbstractMatrixComponent)?.resetSymbols();
        uiFlags.set(UIFlag.IDLE, false);
    }
}
